import { render, staticRenderFns } from "./BookingCommodities.vue?vue&type=template&id=69622b80&scoped=true&"
import script from "./BookingCommodities.vue?vue&type=script&lang=js&"
export * from "./BookingCommodities.vue?vue&type=script&lang=js&"
import style0 from "./BookingCommodities.vue?vue&type=style&index=0&id=69622b80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69622b80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69622b80')) {
      api.createRecord('69622b80', component.options)
    } else {
      api.reload('69622b80', component.options)
    }
    module.hot.accept("./BookingCommodities.vue?vue&type=template&id=69622b80&scoped=true&", function () {
      api.rerender('69622b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/booking/BookingCommodities.vue"
export default component.exports